// pages/FormViewerPage/services/formViewerService/funnelSession.ts — guard idempoten sesi tab (split dari funnelEvents.ts)
export function alreadyFired(sessionKey: string): boolean {
    try {
        if (sessionStorage.getItem(sessionKey)) return true;
        sessionStorage.setItem(sessionKey, '1');
        return false;
    } catch { return false; }
}

// Varian intip-tanpa-tandai utk jalur retry (FormView): kunci sesi HANYA
// dicatat saat event benar-benar terkirim, supaya percobaan ulang tidak
// diblokir guard. JANGAN dipakai utk event yg SDK-nya dijamin ada (fbq stub).
export function hasFiredSessionKey(sessionKey: string): boolean {
    try {
        return !!sessionStorage.getItem(sessionKey);
    } catch { return false; }
}

export function markFiredSessionKey(sessionKey: string): void {
    try {
        sessionStorage.setItem(sessionKey, '1');
    } catch { /* abaikan */ }
}
